import { FC, memo } from 'react';
import { TextField } from '@mui/material';
import { DescriptionOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { TaskPropertyRow } from '../TaskPropertyRow';

interface TaskDescriptionFieldProps {
  value: string;
  isReadOnly?: boolean;
  onChange: (value: string) => void;
  onFocus?: () => void;
}

export const TaskDescriptionField: FC<TaskDescriptionFieldProps> = memo(
  ({ value, isReadOnly = false, onChange, onFocus }) => {
    const { t } = useTranslation();

    return (
      <TaskPropertyRow icon={<DescriptionOutlined className="task-detail-modal__icon" />}>
        <TextField
          placeholder={t('task.modal.descriptionPlaceholder')}
          multiline
          minRows={1}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={onFocus}
          variant="standard"
          className="task-detail-modal__desc-textarea"
          disabled={isReadOnly}
          fullWidth
        />
      </TaskPropertyRow>
    );
  }
);

TaskDescriptionField.displayName = 'TaskDescriptionField';
